import { ParsedUrlQuery } from 'querystring';

export enum PageIds {
  Category = 'category_page',
  Product = 'item_page',
  IndividualBrand = 'brand_page',
  ShoppingCart = 'cart_page',
  Error404 = 'error_page',
  Search = 'search_page',
  PurchaseComplete = 'purchase_complete_page',
  AddProduct = 'add_to_cart_page',
  HomePage = 'home_page',
  CategorySort = 'category_page.sort',
  AddProductToMiniCart = 'add_to_cart_page.rr1',
}

export enum CarouselsPlacements {
  Carousel1 = 'item_page.rr1',
  Carousel2 = 'item_page.rr2',
  Carousel3 = 'item_page.rr3',
  Carousel4 = 'item_page.rr4',
  Carousel5 = 'item_page.rr5',
}

export enum MobileCarouselsPlacements {
  Carousel1 = 'item_page.mrr1',
  Carousel2 = 'item_page.mrr2',
  Carousel3 = 'item_page.mrr3',
  Carousel4 = 'item_page.mrr4',
  Carousel5 = 'item_page.mrr5',
}

export enum BrandCode {
  PYR = '0',
  AV = '1',
  AGD = '2',
}

export type SearchResultContent = {
  numFound: number;
  docs?: Array<Content>;
  facets?: Array<Facets>;
  rcs?: string;
};

export type SearchResultPart = {
  addtoCartParams: string;
  numFound: number;
  docs?: Array<Docs>;
  facets?: Array<Facets>;
  rcs?: string;
};

export type Docs = {
  id: string;
  score: number;
  linkId: string;
  clickUrl: string;
  imageId: string;
  priceCents: number;
  salePriceCents: number;
  name: string;
  rating: number;
  numReviews: number;
  ShortDescription: string;
  Purchasable: string;
  effectivePriceCents: number;
  AddToCartButtonText: string;
  PricePerUnit?: string;
  PricePerUnitLabel?: string;
  NewPriceMin?: string;
  NewPriceMax?: string;
  NewSalePriceMin?: string;
  NewSalePriceMax?: string;
  ProductConditionMax?: string;
  ProductCondition?: Array<string>;
  New?: boolean;
  UsedAnyPriceMin?: string;
};

export interface TopSellingProduct {
  imageId: string;
  linkId: string;
  name: string;
  new: boolean;
  newPriceMax: string | undefined;
  newPriceMin: string | undefined;
  newSalePriceMax: string | undefined;
  newSalePriceMin: string | undefined;
  numReviews: number;
  priceCents: number;
  pricePerUnit: string | undefined;
  pricePerUnitLabel: string | undefined;
  productConditionMax: string | undefined;
  productCondition: Array<string> | undefined;
  rating: number;
  salePriceCents: number;
  usedPriceCents: string | undefined;
  clickTrackingURL?: string;
  id: string;
  relatedProductsImperative: boolean;
  productType: string | undefined;
  serviceId: string | undefined;
  serviceType: string | undefined;
  purchasable: boolean;
  addToCartButtonText: string;
  addToCartOptionId: string;
  tidBit?: string;
  sku?: string;
  discountCents?: number;
  quantity?: number;
}

export type FacetValues = {
  filter: string;
  count: number;
  value: string;
  selected: boolean;
};

export type Facets = {
  facet: string;
  values: Array<FacetValues>;
  min?: number;
  max?: number;
};

export type SearchResultItem = {
  addtoCartParams: string;
  docs: Array<Docs>;
  facets: Array<Facets>;
  numFound: number;
  rcs: string;
  links: Links;
};

export type SearchResult = {
  content: SearchResultContent;
  item: SearchResultItem;
  part: SearchResultPart;
  queryOption: string;
  selectedFiltersAmount: number;
  selectedFiltersExtracted: Array<Facets> | undefined;
  filterTabs: Record<string, FilterTabItem>;
};

export type FilterTabItem = {
  found: number;
  name: string;
};

export type Links = {
  banner: Array<Link>;
  directlink: Array<Link>;
  sponsored: Array<Link>;
};

export type Link = {
  id: string;
  title: string;
  url: string;
};

export type Content = {
  ShortDescription: string;
  clickUrl: string;
  id: string;
  image_url: string;
  link_url: string;
  name: string;
  previewUrl: string;
  score: number;
};

export const sortFiltersPosition: Record<string, number> = {
  productstatus: 0,
  promocategory: 1,
  producttype: 2,
  brand: 3,
  caliber: 4,
  anypricemin: 4,
  effectivepricerange: 4,
  rating: 5,
  ratingrange: 5,
  powerplant: 6,
  use: 7,
  ammotype: 8,
  ammoshape: 9,
  projectileweight: 10,
  projectileweightrange: 10,
  velocity: 11,
  velocityrange: 11,
  loudness: 12,
  color: 13,
  productcondition: 14,
};

export type QueryValues = Record<string, string | Array<string> | undefined>;

export const SortValues: Record<string, string> = {
  popularity: 'SalesVelocity365D desc',
  asc: 'product_effectiveprice_cents asc',
  desc: 'product_effectiveprice_cents desc',
  rating: 'product_rating desc',
};

export type CategorieItem = {
  ancestorCategories: Array<any>;
  childCategories: Array<any>;
  hasChildren: boolean;
  id: string;
  isActive: boolean;
  name: string;
};

export type clickTrackingURL = string | undefined;

export type RecommendedProductItem = {
  attributes: Record<string, Array<string>> | undefined;
  brand: string;
  categories: Array<CategorieItem>;
  categoryIds: Array<string>;
  clickTrackingURL: string;
  clickURL: string;
  genre: string;
  id: string;
  imageURL: string;
  isRecommendable: boolean;
  name: string;
  numReviews: number;
  priceCents: number;
  priceRangeCents: Array<number>;
  productURL: string;
  rating: number;
  regionPriceDescription: string;
  regionalProductSku: string;
  salePriceCents?: number;
  salePriceRangeCents: Array<number>;
  tidBit?: string;
};

export type RecommendedProducts = Array<RecommendedProductItem>;

export type TopSellingProducts = Array<TopSellingProduct>;

export type PlacementItem = {
  html: string;
  htmlElementId: string;
  placement: string;
  placementType: string;
  recommendedProducts: RecommendedProducts;
  strategyMessage: string;
};

export type Placements = Array<PlacementItem>;

export type CarouselsResponse = {
  placements?: Placements;
  rcs: string;
  status: string;
  viewGuid?: string;
};

export type PlacementItemResponse = Omit<PlacementItem, 'recommendedProducts'> & {
  recommendedProducts: TopSellingProducts;
};

export type PlacementsResponse = Array<PlacementItemResponse>;

export type CategoryRequest = Omit<CarouselsResponse, 'placements'> & {
  placements?: PlacementsResponse;
};

export type SearchParams = Record<string, string | undefined | ParsedUrlQuery>;

export type CreativesItem = {
  ASSET_TEXT: string;
  IMAGE_SHAPE: string;
  START_TIME: string;
  CLICK_URL?: string;
  LINK_URL?: string
  trackingUrl: string;
  campaign: string;
  TYPE: string;
  IMAGE_URL: string;
  R_RECOMMEND: string;
}

export type TopBanners = {
  creatives: Array<CreativesItem>;
  html: string;
  placement: string;
};
